import type { PropsWithChildren } from "react"
import * as React from "react"
import { Link } from "react-router-dom-7"
import { isStandalone } from "~/shared/lib/utils"

function Anchor({
	children,
	href,
	...anchorProps
}: PropsWithChildren<
	{ href: string } & Omit<
		React.AnchorHTMLAttributes<HTMLAnchorElement>,
		"href"
	>
>) {
	const isStandaloneFlag = isStandalone()

	return isStandaloneFlag ? (
		<a
			href={href}
			onClick={(e) => {
				e.preventDefault()
				return window.open(href, href.startsWith("/a/")? "_self" : "_blank")
			}}
			{...anchorProps}
		>
			{children}
		</a>
	) : (
		<a href={href} {...anchorProps}>
			{children}
		</a>
	)
}

/**
 * Если свойство `href` содержит относительную ссылку, то компонент использует внутри `<Link>`.
 * В остальных случаях используется `<a>`.
 *
 * @param props
 * @component
 * @category Component
 * @example
 * ```tsx
 * import {Href} from "~/ui/Href";
 *
 * function Example() {
 *     return (
 *         <>
 *             <Href href="/main">ЭИОС</Href> {\/* здесь будет использоваться <Link> *\/*}
 *             <Href href="https://kemsu.ru">Сайт КемГУ</Href> {\/* здесь будет использоваться <a> *\/}
 *         </a>
 *     );
 * }
 * ```
 */
export function Href({
	children,
	href,
	...anchorProps
}: PropsWithChildren<
	{ href: string } & Omit<
		React.AnchorHTMLAttributes<HTMLAnchorElement>,
		"href"
	>
>) {

	// TODO: после полного перехода нужно убрать последнее условие
	if (href && (/https?:\/\//.test(href) || href.startsWith("/a/"))) {
		return (
			<Anchor href={href} {...anchorProps}>
				{children}
			</Anchor>
		)
	}

	return (
		<Link to={href} {...anchorProps}>
			{children}
		</Link>
	)
}
